import React from "react";
import Helmet from "react-helmet"

const Fonts = () => {
    return(
        <Helmet>
            <link 
                href="https://fonts.googleapis.com/css?family=DM+Sans:400,500&display=swap" 
                rel="stylesheet"/>
        </Helmet>
    );
};

export default Fonts;
